import { Skeleton, type SkeletonProps } from '@mui/material';

import { skeletonStyles } from './Skeleton.style';

export const SkeletonBlock: React.FC<SkeletonProps> = (props) => {
	const { classes } = skeletonStyles();
	return <Skeleton className={classes.block} animation="pulse" variant="rounded" {...props} />;
};
